import { RegItem } from 'src/types/regItem'
import { RightDrawer, NavLink } from 'baby-design'

import { useEffect } from 'react'
import { RegItemFields } from './fields/RegItemFields'
import { FavorFields } from './fields/FavorFields'
import { ExternalRegistryFields } from './fields/ExternalRegistryFields'
import { GiftCardFields } from './fields/GiftCardFields'
import { CrowdfundFields } from './fields/CrowdfundFields'
import { GroupGiftFields } from './fields/GroupGiftFields'

import NiceModal, { useModal } from '@ebay/nice-modal-react'
import ConfirmRegItemDeleteModal from '../ConfirmRegItemDeleteModal/ConfirmRegItemDeleteModal'
import GroupGiftRedemptionModal from '../GroupGiftRedemptionModal/GroupGiftRedemptionModal'
import { useRegistry } from '../../utils/useQueries'
import { getCategoriesAsKeyValue } from '../../utils/productHelpers'
import useSaveRegItem from '../../hooks/useSaveRegItem'

interface EditRegItemDrawerProps {
  regItem: RegItem
}

export default NiceModal.create(({ regItem }: EditRegItemDrawerProps) => {
  const modal = useModal()
  const {
    saveRegItemMutation,
    onSave,
    regItemChanges,
    setRegItemChanges,
    handleClose,
    hasUnsavedChanges,
    clearRegItemFields,
    updateRegItemFields,
  } = useSaveRegItem({ regItem, modal })

  const categories = getCategoriesAsKeyValue(useRegistry()?.categories || [])

  const regItemFields: RegItem = {
    ...regItem,
    ...regItemChanges,
  }

  useEffect(() => {
    setRegItemChanges({})
  }, [modal.visible])

  const handleDelete = async () => {
    if (regItem.isGroupGift) {
      const confirmGroupGiftRedemption: boolean | undefined =
        await NiceModal.show(GroupGiftRedemptionModal, {
          regItem: regItem,
          action: 'delete-reg-item',
        })
      if (confirmGroupGiftRedemption) {
        modal.hide()
      }
      return
    }

    const confirmDeleteModal: boolean = await NiceModal.show(
      ConfirmRegItemDeleteModal,
      { regItem: regItem }
    )
    if (confirmDeleteModal) {
      modal.hide()
    }
  }

  let Fields = RegItemFields
  if (regItem.isFavor) {
    Fields = FavorFields
  } else if (regItem.isExternalRegistry) {
    Fields = ExternalRegistryFields
  } else if (regItem.isGiftCard) {
    Fields = GiftCardFields
  } else if (regItem.isCrowdfund) {
    Fields = CrowdfundFields
  } else if (regItem.isGroupGift) {
    Fields = GroupGiftFields
  }

  return (
    <RightDrawer
      handleClose={handleClose}
      handleDismount={modal.remove}
      isOpen={modal.visible}
      title="Edit Item Details"
      contextualIcon={
        <NavLink
          variant="eggplant"
          size="md"
          onClick={onSave}
          disabled={saveRegItemMutation.isLoading || !hasUnsavedChanges()}
        >
          Save
        </NavLink>
      }
    >
      <Fields
        regItem={regItem}
        categories={categories}
        regItemFields={regItemFields}
        updateRegItemFields={updateRegItemFields}
        clearRegItemFields={clearRegItemFields}
        handleDelete={handleDelete}
      />
    </RightDrawer>
  )
})
